import React from "react";
import SignaturePad from "react-signature-canvas";
import SignatureCanvas from "react-signature-canvas";
import { ETAPA_ENTREGA_CHAVES } from "../../../Constants/EntregaChaves";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import { InserirDocumentoDiretoEmCasoController } from "../../../Controllers/Geral/CasoDocumentos/CasoDocumentosController";
import { DocumentoCasoContaController } from "../../../Controllers/Geral/Documentos/DocumentosController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IAtendimentoExtraDetalhado } from "../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { Spinner } from "../../Loding/SpinnerPadrao";
import { CadastratarTipoDocumentoController, ListarTipoDocumentoController } from "../../../Controllers/Geral/GestaoDeCadastros/TipoDocumento/TipoDocumentoController";
import { TipoDocumentoInterface } from "../../../Interfaces/Geral/GestaoDeCadastro/TipoDocumento/TipoDocumentoInterface";

interface IBlocoAssinaturaProps {
    idCaso: number;
    flAssinarTermo?: boolean;
}

export default function BlocoAssinaturaEntregaChaves(
    props: IBlocoAssinaturaProps
) {
    const AtendimentoPage = useAtendimentoPage();
    const Atendimento =
        AtendimentoPage.Atendimento as IAtendimentoExtraDetalhado;

    const imagemInicial =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC";

    const padRef1 = React.useRef<SignatureCanvas>(null);
    const padRef2 = React.useRef<SignatureCanvas>(null);

    const { execute: salvarAssinatura, loading: salvarAssinaturaLoading } =
        useAsyncCallback(InserirDocumentoDiretoEmCasoController);

    const trim = (index: number) => {
        let assinatura: TipoDocumentoInterface | undefined = lstTipoDocumento?.filter(
            x => x.DS_TIPO_DOCUMENTO.trim() === "Assinatura"
        )[0];
        const url =
            index === 0
                ? padRef1.current?.getTrimmedCanvas().toDataURL("image/png")
                : padRef2.current?.getTrimmedCanvas().toDataURL("image/png");
        if (url) {
            const splitedUrl = url.split(",");
            if (splitedUrl[1].length > 800 && assinatura && assinatura.ID_TIPO_DOCUMENTO !== 0) {
                salvarAssinatura({
                    ID_CASO: props.idCaso,
                    IM_DOCUMENTO: splitedUrl[1],
                    DS_TIPO: "image/png",
                    ID_TIPO_DOCUMENTO: assinatura.ID_TIPO_DOCUMENTO,
                    DS_DOCUMENTO: `Assinatura_Entrega_Chaves_${index === 0 ? "Cliente" : "Tecnico"
                        }_${props.idCaso}_${Atendimento.CD_ETAPA}.png`,
                }).then(() => {
                    AtendimentoPage.updateAtendimento();
                });
            } else if (splitedUrl[1].length > 800) {
                CadastratarTipoDocumentoController({
                    DS_TIPO_DOCUMENTO: "Assinatura",
                    ID_CLASSIFICACAO_DOCUMENTO: 3, // ID Classificação de documento - Caso
                }).then(() => {
                    listarTipoDocumento().then(() => {
                        assinatura = lstTipoDocumento?.filter(
                            x => x.DS_TIPO_DOCUMENTO.trim() === "Assinatura"
                        )[0];
                        if (assinatura && assinatura.ID_TIPO_DOCUMENTO) {
                            salvarAssinatura({
                                ID_CASO: props.idCaso,
                                IM_DOCUMENTO: splitedUrl[1],
                                DS_TIPO: "image/png",
                                ID_TIPO_DOCUMENTO: assinatura.ID_TIPO_DOCUMENTO,
                                DS_DOCUMENTO: `Assinatura_Entrega_Chaves_${index === 0 ? "Cliente" : "Tecnico"
                                    }_${props.idCaso}_${Atendimento.CD_ETAPA}.png`,
                            }).then(() => {
                                AtendimentoPage.updateAtendimento();
                            });
                        }
                    });
                });
            }
        }
    };

    const clear = (index: number) => {
        index === 0 ? padRef1.current?.clear() : padRef2.current?.clear();
    };

    const { value: assinaturaCliente } = useAsyncEffect(async () => {
        return DocumentoCasoContaController(
            0,
            `Assinatura_Entrega_Chaves_Cliente_${props.idCaso}_${Atendimento.CD_ETAPA}.png`,
            props.idCaso
        );
    }, [salvarAssinaturaLoading]);

    const { value: assinaturaTecnico } = useAsyncEffect(async () => {
        return DocumentoCasoContaController(
            0,
            `Assinatura_Entrega_Chaves_Tecnico_${props.idCaso}_${Atendimento.CD_ETAPA}.png`,
            props.idCaso
        );
    }, [salvarAssinaturaLoading]);

    const { execute: listarTipoDocumento, value: lstTipoDocumento } = useAsyncEffect(async () => {
        return ListarTipoDocumentoController();
    }, []);

    const assinaturaClienteImg = assinaturaCliente?.IM_DOCUMENTO
        ? assinaturaCliente.IM_DOCUMENTO
        : assinaturaCliente?.DS_LINK_DRIVE;

    const assinaturaTecnicoImg = assinaturaTecnico?.IM_DOCUMENTO
        ? assinaturaTecnico.IM_DOCUMENTO
        : assinaturaTecnico?.DS_LINK_DRIVE;

    function handleFormatoSRC(index: number) {
        const splitedLink = assinaturaTecnico?.DS_LINK_DRIVE
            ? assinaturaTecnico.DS_LINK_DRIVE
            : assinaturaCliente?.DS_LINK_DRIVE;

        const split = splitedLink?.split("/");
        const driveFileId = split ? split[split.length - 2] : "00";

        if (assinaturaCliente?.IM_DOCUMENTO && index === 0) {
            return `data:image/png;base64,${assinaturaCliente.IM_DOCUMENTO}`;
        } else if (assinaturaCliente?.DS_LINK_DRIVE && index === 0) {
            return `https://docs.google.com/uc?id=${driveFileId}`;
        } else if (assinaturaTecnico?.IM_DOCUMENTO && index === 1) {
            return `data:image/png;base64,${assinaturaTecnico.IM_DOCUMENTO}`;
        } else if (assinaturaTecnico?.DS_LINK_DRIVE && index === 1) {
            return `https://docs.google.com/uc?id=${driveFileId}`;
        }
    }

    function handleTecnicoAssinar() {
        return [
            ETAPA_ENTREGA_CHAVES.RESPONDER_VISTORIA_PREVIA_NAO_CONFORME_ELETRICA
                .CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_FORMULARIO_CONFORME.CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_FORMULARIO_NAO_CONFORME.CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_OBRA_CONCLUIDA_ACEITE_UNIDADE
                .CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_VISTORIA_PREVIA_CONFORME_UNIDADE
                .CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_VISTORIA_PREVIA_NAO_CONFORME_UNIDADE
                .CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_VISTORIA_PREVIA_NAO_CONFORME_ELETRICA
                .CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_VISTORIA_PREVIA_CONFORME_ELETRICA
                .CD_ETAPA,
            props.flAssinarTermo &&
            ETAPA_ENTREGA_CHAVES.ENTREGA_REALIZADA_ASSINAR_TERMO.CD_ETAPA,
        ].some((etapa) => etapa === Atendimento.CD_ETAPA);
    }

    function handleClienteAssinar() {
        return [
            ETAPA_ENTREGA_CHAVES.RESPONDER_FORMULARIO_CONFORME.CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_FORMULARIO_NAO_CONFORME.CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_OBRA_CONCLUIDA_ACEITE_UNIDADE.CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.ENTREGA_REALIZADA_ASSINAR_TERMO.CD_ETAPA,
        ].some((etapa) => etapa === Atendimento.CD_ETAPA);
    }

    function handleAssinar() {
        return [
            ETAPA_ENTREGA_CHAVES.RESPONDER_FORMULARIO_CONFORME.CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_FORMULARIO_NAO_CONFORME.CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_VISTORIA_PREVIA_CONFORME_ELETRICA
                .CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_VISTORIA_PREVIA_NAO_CONFORME_ELETRICA
                .CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.ENTREGA_REALIZADA_ASSINAR_TERMO.CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_OBRA_CONCLUIDA_ACEITE_UNIDADE
                .CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_VISTORIA_PREVIA_CONFORME_UNIDADE
                .CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.RESPONDER_VISTORIA_PREVIA_NAO_CONFORME_UNIDADE
                .CD_ETAPA,
        ].some((etapa) => etapa === Atendimento.CD_ETAPA);
    }

    return handleAssinar() ? (
        <div className=" mt-3 mb-3 col-12 mr-0 ml-0 pr-0 pl-0 card card-custom p-2 mt-2">
            <div className="d-flex justify-content-center align-items-center col-12">
                <h2 className="m-3">Assinaturas</h2>
            </div>
            {Array(2)
                .fill("")
                .map(
                    (_assinatura, index) =>
                        ((handleClienteAssinar() && index === 0) ||
                            (handleTecnicoAssinar() && index === 1)) && (
                            <div
                                className="d-flex justify-content-center align-items-center flex-wrap g-3"
                                key={index}
                            >
                                <div className="d-flex justify-content-center align-items-center flex-column">
                                    <h5>
                                        Favor Assinar -{" "}
                                        {index === 0 ? "Cliente" : "Técnico"}
                                    </h5>

                                    <div
                                        className="border border-secondary"
                                        id=""
                                    >
                                        <SignaturePad
                                            canvasProps={{
                                                width: 400,
                                                height: 145,
                                                className: "sigCanvas",
                                            }}
                                            ref={
                                                index === 0 ? padRef1 : padRef2
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="d-flex flex-column align-items-center justify-content-center">
                                    <h5>Assinatura</h5>
                                    <div className="border border-secondary">
                                        {(index === 0 &&
                                            assinaturaClienteImg) ||
                                            (index === 1 &&
                                                assinaturaTecnicoImg) ? (
                                            <>
                                                <img
                                                    className={"sigImage"}
                                                    src={handleFormatoSRC(
                                                        index
                                                    )}
                                                    alt="Assinatura do usúario"
                                                    style={{
                                                        height: 150,
                                                        width: 400,
                                                        resize: "initial",
                                                    }}
                                                />
                                            </>
                                        ) : (
                                            <img
                                                className={"sigImage"}
                                                src={imagemInicial}
                                                alt="Assinatura do usúario em branco"
                                                style={{
                                                    height: 150,
                                                    width: 400,
                                                    resize: "initial",
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex justify-content-around col-12 mt-2 mb-2">
                                    <button
                                        className="btn btn-outline-danger"
                                        type="button"
                                        onClick={() => clear(index)}
                                        style={{ width: 80, height: 40 }}
                                    >
                                        Apagar
                                    </button>
                                    <button
                                        className="btn btn-outline-primary"
                                        type="button"
                                        onClick={() => trim(index)}
                                        disabled={salvarAssinaturaLoading}
                                        style={{ width: 90, height: 40 }}
                                    >
                                        {salvarAssinaturaLoading ? (
                                            <>
                                                <span>Assinar</span>
                                                <Spinner size="sm" />
                                            </>
                                        ) : (
                                            <span>Assinar</span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        )
                )}
        </div>
    ) : null;
}
